import { features, journey } from '../../data/content';
import companyImage from '../../img/corn-bliss-images/photo-2025-09-28-20-13-57-5-jpg.jpeg';
import cornMountain from '../../img/corn-bliss-images/cornmountain.png';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page-wrapper">

      {/* ══ HERO ══ */}
      <section className="about-hero">
        <div className="about-hero-image-panel">
          <img src={companyImage} alt="Corn Bliss processing unit" />
        </div>

        <div className="about-hero-content">
          <span className="about-hero-kicker">About Corn Bliss</span>

          <h1>
            Sri Lanka's <em>Leading</em> Frozen Sweet Corn Manufacturer
          </h1>

          <p className="about-hero-desc">
            Pure, natural, and preservative-free. Harvested from the Badulla highlands
            and processed with care — bringing the freshest corn to tables across Sri Lanka and beyond.
          </p>

          <div className="about-mini-cards">
            <div className="about-mini-card">
              <h3>Exporters</h3>
              <p>Frozen sweet corn &amp; baby corn products worldwide.</p>
            </div>
            <div className="about-mini-card">
              <h3>3,000+ MT</h3>
              <p>Annual processing capacity across all operations.</p>
            </div>
          </div>

          <div className="about-hero-stats">
            <div className="stat-item">
              <span className="stat-num">100+</span>
              <span className="stat-label">Families Served</span>
            </div>
            <div className="stat-item">
              <span className="stat-num">0</span>
              <span className="stat-label">Preservatives</span>
            </div>
            <div className="stat-item">
              <span className="stat-num">24/7</span>
              <span className="stat-label">Always Open</span>
            </div>
          </div>

          <a className="about-cta-btn" href="tel:+94770000000">
            Call Us Now
          </a>
        </div>
      </section>

      {/* ══ BRAND STORY ══ */}
      <section className="about-section about-story-section">
        <div className="about-story-inner">

          {/* Left — text */}
          <div className="about-story-text">
            <span className="about-section-label">Our Story</span>
            <h2 className="about-section-title">
              Grown with Love,<br />Made for <em className="about-title-em">You</em>
            </h2>

            <p className="about-story-para">
              <strong>Corn Bliss is proudly made in Sri Lanka</strong> using 100% natural
              ingredients, with no preservatives added. Our sweetcorn is grown in our own
              lands together with the support of local farmers — ensuring freshness, quality,
              and authentic Sri Lankan goodness in every product. Healthy, delicious, and
              naturally made for your family.
            </p>

            <p className="about-story-para">
              From farming to production, <strong>every step is handled by our own team</strong> with
              care and dedication. We support local agriculture, empower Sri Lankan farmers,
              and turn freshly harvested sweetcorn into quality products you can trust.
              Corn Bliss is a true 100% Sri Lankan product — made by our people, from our
              land, for everyone.
            </p>

            {/* Flag banner */}
            <div className="about-story-flag">
              <span className="about-story-flag-emoji">🇱🇰</span>
              <div>
                <p className="about-story-flag-title">Proudly Made in Sri Lanka</p>
                <p className="about-story-flag-sub">
                  From Badulla's highlands to your table — every kernel tells the story
                  of our land, our farmers, and our commitment to wholesome goodness.
                </p>
              </div>
              <span className="about-story-flag-badge">100% Sri Lankan</span>
            </div>
          </div>

          {/* Right — pillars */}
          <div className="about-story-pillars">

            <div className="about-story-pillar">
              <div className="about-story-pillar-icon">🌱</div>
              <div>
                <p className="about-story-pillar-title">100% Natural &amp; Preservative-Free</p>
                <p className="about-story-pillar-desc">
                  No additives, no shortcuts. Just pure, naturally sweet corn harvested
                  at peak ripeness and packed straight from the farm.
                </p>
              </div>
            </div>

            <div className="about-story-pillar">
              <div className="about-story-pillar-icon">🤝</div>
              <div>
                <p className="about-story-pillar-title">Supporting Local Farmers</p>
                <p className="about-story-pillar-desc">
                  We partner with Sri Lankan farmers to grow our sweetcorn sustainably,
                  empowering local agriculture and rural communities.
                </p>
              </div>
            </div>

            <div className="about-story-pillar">
              <div className="about-story-pillar-icon">🏡</div>
              <div>
                <p className="about-story-pillar-title">Farm-to-Table Quality</p>
                <p className="about-story-pillar-desc">
                  Every step — farming, harvesting, production and packaging — is managed
                  in-house by our own team so quality is never compromised.
                </p>
              </div>
            </div>

            <div className="about-story-pillar">
              <div className="about-story-pillar-icon">🌽</div>
              <div>
                <p className="about-story-pillar-title">Badulla Highland Harvests</p>
                <p className="about-story-pillar-desc">
                  Grown at elevation in Sri Lanka's fertile highlands, our corn develops
                  a naturally sweeter flavour and firmer kernel you can taste.
                </p>
              </div>
            </div>

          </div>

          {/* Right — farm image */}
          <div className="about-story-img-panel">
            <img src={cornMountain} alt="Corn fields in the Badulla highlands" />
            {/* <div className="about-story-img-caption">
              <span>🌽</span>
              <p>Our sweetcorn fields in the Badulla highlands</p>
            </div> */}
          </div>

        </div>
      </section>

      {/* ══ JOURNEY ══ */}
      <section className="about-section about-journey-section">
        <span className="about-section-label">How We Work</span>
        <h2 className="about-section-title">From Farm to You</h2>

        <div className="about-journey-grid">
          {journey.map((step, i) => (
            <div key={step.title} className="about-journey-card">
              <span className="journey-card-num">{String(i + 1).padStart(2, '0')}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ══ WHY CHOOSE US ══ */}
      <section className="about-section about-why-section">
        <span className="about-section-label">Our Promise</span>
        <h2 className="about-section-title">Why Choose Corn Bliss</h2>

        <div className="about-why-grid">
          {features.map((feature) => (
            <div key={feature} className="about-why-card">
              <div className="why-check">✓</div>
              <p className="why-card-text">{feature}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}

export default AboutPage;